module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "whatsapart",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.whats_apart_bg + ')'
    })
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.whats_apart_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.whats_apart_title)
    }
  }) : _vm._e(), (_vm.props.acf.whats_apart_intro) ? _c('div', {
    staticClass: "apart_content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.whats_apart_intro)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "apart_btn"
  }, [_c('span', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal1",
      modifiers: {
        "modal1": true
      }
    }]
  }, [(_vm.props.acf.whats_apart_btn_text) ? _c('span', {
    staticClass: "apartbtn",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.whats_apart_btn_text)
    }
  }) : _vm._e()])])])]), _c('div', {
    staticClass: "footerwidgetsection",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.footer_widhet_bg_img + ')'
    })
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [(_vm.props.acf.left_widget_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.left_widget_title)
    }
  }) : _vm._e(), (_vm.props.acf.address) ? _c('div', {
    staticClass: "address_footer",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.address)
    }
  }) : _vm._e(), _c('h5', [(_vm.propshead.acf.phone) ? _c('a', {
    attrs: {
      "href": "tel:" + _vm.propshead.acf.phone,
      "itemprop": "telephone"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.propshead.acf.phone)
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "col-md-4 col-sm-12 footerlogo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [(_vm.props.acf.footer_logo) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.footer_logo,
      "alt": ""
    }
  }) : _vm._e()])], 1), _c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('div', {
    staticClass: "sociallist"
  }, _vm._l((_vm.propshead.acf.social_list), function(SocialList) {
    return (_vm.propshead.acf.social_list) ? _c('a', {
      attrs: {
        "href": SocialList.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": SocialList.img,
        "alt": ""
      }
    })]) : _vm._e()
  })), _c('div', {
    staticClass: "providers_list"
  }, [_c('a', {
    staticClass: "providerclick",
    on: {
      "click": function($event) {
        _vm.provider1Click()
      }
    }
  }, [(_vm.props.acf.footer_providers_1_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.footer_providers_1_img,
      "alt": ""
    }
  }) : _vm._e()]), _c('a', {
    staticClass: "providerclick",
    on: {
      "click": function($event) {
        _vm.provider2Click()
      }
    }
  }, [(_vm.props.acf.footer_providers_2_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.footer_providers_2_img,
      "alt": ""
    }
  }) : _vm._e()]), _c('a', {
    staticClass: "providerclick",
    on: {
      "click": function($event) {
        _vm.provider3Click()
      }
    }
  }, [(_vm.props.acf.footer_providers_3_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.footer_providers_3_img,
      "alt": ""
    }
  }) : _vm._e()]), _c('a', {
    staticClass: "providerclick",
    on: {
      "click": function($event) {
        _vm.provider4Click()
      }
    }
  }, [(_vm.props.acf.footer_providers_4_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.footer_providers_4_img,
      "alt": ""
    }
  }) : _vm._e()])])])])])]), _c('div', {
    staticClass: "footercopyright_section"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('p', [_c('span', [_vm._v("© " + _vm._s(new Date().getFullYear()) + " ")]), (_vm.props.acf.footer_copyright_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.footer_copyright_text)
    }
  }) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58ab3f0c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 824
// module chunks = 1